import { useEffect } from 'react'

import { useCart } from '@/contexts/CartContext'
import { useRegisterContext } from '@/contexts/RegisterContext'
import { lineNet } from '@/services'
import { postToDisplay } from '@/services/customerDisplay'
import { useReceiptHeader } from '@/services/printer'

/** Keeps the customer display (if one is open) in step with the cart. Renders nothing. */
export const CustomerDisplayFeed = () => {
  const { lines, totals, customer } = useCart()
  const register = useRegisterContext()
  const { name: shop } = useReceiptHeader()

  useEffect(() => {
    postToDisplay({
      type: 'cart',
      shop,
      currency: register.currency,
      customer: customer?.name,
      totals,
      lines: lines.map((l) => ({ id: l.product._id, name: l.product.name, quantity: l.quantity, price: l.product.price, net: lineNet(l) })),
    })
  }, [lines, totals, customer, shop, register.currency])

  return null
}
